import { createAsyncThunk } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import {
	getBreachCategoryList as getBreachCategoryListApi,
	getBreachCategoryListQuery as getBreachCategoryListQueryApi,
	getBreachCategoryById as getBreachCategoryByIdApi,
	addNewBreachCategoryApi,
	updateBreachCategoryApi,
	deleteBreachCategoryApi,
	checkBreachCategoryExistsApi,
} from '../../helpers/breach_category/api_helper';

export const getBreachCategoryList = createAsyncThunk(
	'breachCategory/getBreachCategoryList',
	async params => {
		try {
			const response = await getBreachCategoryListApi(params);
			return response.data || response;
		} catch (error) {
			toast.error('Error al obtener categorias de incumplimiento.', {
				autoClose: 3000,
			});
			throw new Error(error);
		}
	}
);

export const getBreachCategoryListQuery = createAsyncThunk(
	'breachCategory/getBreachCategoryListQuery',
	async params => {
		try {
			const response = getBreachCategoryListQueryApi(params);
			return response;
		} catch (error) {
			throw new Error(error);
		}
	}
);

export const getBreachCategory = createAsyncThunk(
	'breachCategory/getBreachCategory',
	async id => {
		try {
			const response = await getBreachCategoryByIdApi(id);
			return response;
		} catch (error) {
			toast.error('Error al obtener la categoría de incumplimiento.', {
				autoClose: 3000,
			});
			throw new Error(error);
		}
	}
);

export const addNewBreachCategory = createAsyncThunk(
	'breachCategory/addNewBreachCategory',
	async breachCategory => {
		try {
			const response = await addNewBreachCategoryApi(breachCategory);
			toast.success('Categoría de Incumplimiento agregada exitosamente.', {
				autoClose: 3000,
			});
			return response.data || response;
		} catch (error) {
			toast.error('Error al agregar la categoría de incumplimiento.', {
				autoClose: 3000,
			});
			throw new Error(error);
		}
	}
);

export const updateBreachCategory = createAsyncThunk(
	'breachCategory/updateBreachCategory',
	async breachCategory => {
		try {
			const response = await updateBreachCategoryApi(breachCategory);
			toast.success('Categoría de Incumplimiento actualizada exitosamente.', {
				autoClose: 3000,
			});
			return response.data || response;
		} catch (error) {
			toast.error('Error al actualizar la categoría de incumplimiento.', {
				autoClose: 3000,
			});
			throw new Error(error);
		}
	}
);

export const deleteBreachCategory = createAsyncThunk(
	'breachCategory/deleteBreachCategory',
	async breachCategory => {
		try {
			await deleteBreachCategoryApi(breachCategory._id);
			toast.success('Categoría de Incumplimiento eliminada exitosamente.', {
				autoClose: 3000,
			});
			return breachCategory;
		} catch (error) {
			toast.error('Error al eliminar la categoría de incumplimiento.', {
				autoClose: 3000,
			});
			throw new Error(error);
		}
	}
);

export const checkBreachCategoryExists = createAsyncThunk(
	'breachCategory/checkBreachCategoryExists',
	async name => {
		try {
			const response = await checkBreachCategoryExistsApi(name);
			return response;
		} catch (error) {
			return { exists: false };
		}
	}
);
